// extracted by mini-css-extract-plugin
export default {"edit_your_box":"lm","edit_box_title":"mm","subscription":"nm","byb":"om","recommended_for_you_title":"pm","explore":"qm","recommended":"rm","go_back":"sm","wrapper":"tm","product_img":"um","info":"vm","remove_btn":"wm"};
    if(module.hot) {
      // 1743628918731
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  